import type { ApiResponse } from "@entrilia/shared/api/types";
import type {
  AnyReportConfigurationForRunning,
  Report,
  ReportAuthorizationInfo,
  TabularReportConfigurationForRunning,
} from "../../../../../api/types/svTypes.ts";
import { getPreconditionFailedMessage } from "./getPreconditionFailedMessage.ts";

export const manageReportSwitching = (
  isSwitchingReport: boolean,
  setSwitchingReport: (v: boolean) => void,
  getReport: () => Promise<void>
) => {
  if (isSwitchingReport) {
    setSwitchingReport(true);
  }
  getReport().finally(() => {
    setSwitchingReport(false);
  });
};

export const getExistingReportWithAuth = async (
  getReport: () => Promise<ApiResponse<Report>>,
  getReportRunningData: (() => Promise<ApiResponse<AnyReportConfigurationForRunning>>) | undefined,
  getReportAuthorizationInfo: () => Promise<ApiResponse<ReportAuthorizationInfo>>,
  onReportNotFound: (reason?: string) => void,
  onReportFound: (report: Report, runningData: AnyReportConfigurationForRunning) => void,
  onSuccessfulAuthorization: (authorizationInfo: ReportAuthorizationInfo) => void
) => {
  try {
    const [reportResp, runningData, authorizationResp] = await Promise.all([
      getReport(),
      getReportRunningData?.() ?? Promise.resolve({ success: true, data: {} as TabularReportConfigurationForRunning }),
      getReportAuthorizationInfo(),
    ]);
    if (reportResp.success && reportResp.data !== undefined && runningData.success && runningData.data !== undefined) {
      onReportFound(reportResp.data, runningData.data);
    } else {
      const runningError = "error" in runningData ? runningData.error : undefined;
      onReportNotFound(runningError?.type === "PreconditionFailed" ? runningError.message : undefined);
    }

    if (authorizationResp.success && authorizationResp.data !== undefined) {
      onSuccessfulAuthorization(authorizationResp.data);
    }
  } catch (error) {
    onReportNotFound(getPreconditionFailedMessage(error));
  }
};
